import { identity, pipe } from 'ramda';
import { isEmpty } from 'lodash';
import {
  UPDATE_FILTER,
  CLEAR_SHOPS,
  RECEIVE_SHOPS,
  REQUEST_SHOP,
  REQUEST_SHOPS,
  RECEIVE_SHOP,
} from '../constants';
import {
  checkRoute,
  checkStatus,
  handleRequestError,
} from '../utils/helpers';
import config from '../../config';
import bayAreaShops from '../applicationServices/bayAreaShops';

const SHOP_INCLUDES = 'include=services,photos,address,reward,schedules,waitingLists,logo';

export function clearShops() {
  return { type: CLEAR_SHOPS };
}

export function requestShops() {
  return {
    type: REQUEST_SHOPS,
  };
}

export function updateFilter(filter) {
  return {
    type: UPDATE_FILTER,
    payload: filter,
  };
}

export function receiveShops(shops) {
  return {
    type: RECEIVE_SHOPS,
    payload: shops,
  };
}

function shouldFetchShops(state) {
  if (!state.shops.items.length && !state.isFetching) {
    return true;
  }
  return true;
}

function fetchShopsAction({ lat, lng, searchName, city }, clear = true, filter = identity) {
  return (dispatch, getState) => {
    if (!shouldFetchShops(getState())) return Promise.resolve();

    if (clear) dispatch(clearShops());
    dispatch(requestShops());

    const cityFilter = city && city !== '-1';
    const searchFilter = !!searchName;
    const coordFilter = (lat && lng) && !(cityFilter || searchFilter);
    const ipFilter = !(lat && lng) && !(cityFilter || searchFilter);

    const url = `${config.url}/shop?${SHOP_INCLUDES}${
       coordFilter ? `&lat=${lat}&lng=${lng}` : ''
       }${cityFilter ? `&city=${city}` : ''
       }${searchFilter ? `&name__like=${searchName}` : ''
       }&limit=1000${ipFilter ? '&searchByIp=true' : ''}`;

    return fetch(url)
      .then(checkStatus)
      .then(pipe(
        filter,
        receiveShops,
        dispatch,
      ))
      .catch(handleRequestError(dispatch));
  };
}
export const fetchShops = bayAreaShops.fetchShops(clearShops, fetchShopsAction);

export const fetchShopsById = ids => (dispatch) => {
  if (isEmpty(ids)) return null;
  dispatch(requestShops());
  const shopsFilter = `id__in=${ids.join(',')}`;
  const url = `${config.url}/shop?${SHOP_INCLUDES}&${shopsFilter}`;

  return fetch(url)
    .then(checkStatus)
    .then(shops => dispatch(receiveShops(shops)))
    .catch(handleRequestError(dispatch));
};

function requestShop(route) {
  return {
    type: REQUEST_SHOP,
    payload: route,
  };
}

function receiveShop(shop) {
  return {
    type: RECEIVE_SHOP,
    payload: shop,
  };
}

function shouldFetchShop(state, route) {
  return state.shops.items && !state.shops.items.find(shop => shop.route === route);
}

export function fetchShop(route, urlPattern) {
  return (dispatch, getState) => {
    if (!shouldFetchShop(getState(), route)) {
      return Promise.resolve();
    }

    dispatch(requestShop(route));

    const url = `${config.url}/shop/${route}?${SHOP_INCLUDES}`;

    return fetch(url)
      .then(checkRoute(dispatch, {}, urlPattern))
      .then(checkStatus)
      .then(shop => dispatch(receiveShop(shop)))
      .catch(handleRequestError(dispatch));
  };
}



// WEBPACK FOOTER //
// ./src/app/shops/actions.js